module.exports = __webpack_public_path__ + "static/media/workPvcCoatings5.08e71d6e.jpg";